.vendor-lead-billing-info-stepper__container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: stretch;

  gap: 16px;
}

.vendor-lead-billing-info-stepper__container .vendor-lead-billing-info-stepper__step {
  position: relative;
  padding: 8px 12px 8px 16px;

  border-radius: 12px;
  border: 2px solid #CCCFD8;

  background-color: white;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;

  gap: 8px;
}

.vendor-lead-billing-info-stepper__container .vendor-lead-billing-info-stepper__step-number {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  color: #555768;
}

.vendor-lead-billing-info-stepper__container .vendor-lead-billing-info-stepper__step-title {
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: #272832;
  white-space: pre-wrap;
}

@media screen and (width <=640px) {
  .vendor-lead-billing-info-stepper__container {
    // viewport width - `vendor-lead-billing-info-step__layout.padding` left+right
    width: calc(100vw - 32px);
    overflow-x: scroll;

    scrollbar-color: transparent transparent;
    scrollbar-width: 0;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .vendor-lead-billing-info-stepper__container .vendor-lead-billing-info-stepper__step {
    flex: 1;

    min-width: 75vw;

    flex-flow: row nowrap;
    align-items: center;
  }

  .vendor-lead-billing-info-stepper__container__start-page .vendor-lead-billing-info-stepper__step {
    min-width: unset;
    max-width: unset;
  }
}